import { render, staticRenderFns } from "./MyRecipesTable.vue?vue&type=template&id=d0be3db4"
import script from "./MyRecipesTable.vue?vue&type=script&lang=js"
export * from "./MyRecipesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports